<template>
<div>
  <common-header></common-header>
  <div class="validate">
    <div class="container">
      <div class="validate-tabs">
        <span
          class="validate-tabs-item"
          v-for="(item, index) in lanInfo.tabTitle"
          :key="index"
          :class="[showTab == index ? $route.path.indexOf('en')==1?'active':'actives':'']"
          :style="{'width':$route.path.indexOf('en')==1?index==0?'152px':'230px':(index==2||index==3?'200px':index==4?'265px':'152px'),'padding':$route.path.indexOf('en')==1?'0px 15px':'0px','border-right':indArr.includes(index)?'0px':'1px solid #c62e3f'}"
          @click="handShowTab(index)"
        >{{item}}</span>
      </div>
       <certificate @noReal="noReal" v-show="showTab == 0" :info="lanInfo.tab_1"></certificate>
      <electronic @noReal="noReal" v-show="showTab == 1" :info="lanInfo.tab_2"></electronic>
      <bj-certificate @noReal="noReal" v-show="showTab == 2" :info="lanInfo.tab_3"></bj-certificate>
      <gz-certificate @noReal="noReal" v-show="showTab == 3" :info="lanInfo.tab_4"></gz-certificate>
      <hz-certificate @noReal="noReal" v-show="showTab == 4" :info="lanInfo.tab_5"></hz-certificate>
    </div>
    <div class="real-shade" v-show="isrealStatus">
      <div class="real-pop">
        <div class="real-logo"></div>
        <span class="real-close" @click="realClose"></span>
        <p class="real-title">{{lanInfo.noRealTip}}</p>
        <span class="real-roger" @click="realClose">{{lanInfo.iKnow}}</span>
      </div>
    </div>
  </div>
  <!-- <loading-absolute v-if="$store.state.showLoading"></loading-absolute> -->
</div>

</template>
<script>

import certificate from "./certificate.vue";
import electronic from "./electronic.vue";
import bjCertificate from "./bjCertificate.vue";
import gzCertificate from "./gzCertificate.vue";
import hzCertificate from "./hzCertificate.vue";
import LoadingAbsolute from '../common/LoadingAbsolute'
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showTab: 0,
      isrealStatus: false,
      indArr:[0,1,2,3],
      tabsList: [
        "证书查询",
        "电子数据保全验证",
        "北京互联网法院存证查询",
        "广州互联网法院存证查询"
      ]
    };
  },
  computed: {
    ...mapGetters(['getLanInfo']),
    lanInfo() {
      return this.getLanInfo.validateQuery
    }
  },
  components: {
    certificate,
    electronic,
    bjCertificate,
    gzCertificate,
    LoadingAbsolute,
    hzCertificate
  },
  methods: {
    handShowTab(i) {
      this.showTab = i;
    },
    // 打开实名认证
    noReal(val) {
      this.isrealStatus = true;
    },
    // 关闭实名认证
    realClose() {
      this.isrealStatus = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.validate {
  position: relative;
  z-index: 0;
  height: 100%;
  background: url("~img/validateQuery/banner_bg_img.png") center no-repeat;
  background-size: 100% 100%;
  .container {
    // width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    padding-bottom: 30px;
    width: 1329px;
  }
  &-tabs {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    &-item {
      width: 152px;
      display: inline-block;
      min-width: 140px;
      height: 44px;
      line-height: 44px;
      border: 1px solid #c62e3f;
      text-align: center;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &.active {
        width: auto !important;
        background-color: #c62e3f;
      }
      &.actives {
        background-color: #c62e3f;
      }
    }
  }
  .real-shade {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(14, 9, 9, 0.4);
    z-index: 20;
    .real-pop {
      position: absolute;
      top: 290px;
      left: 50%;
      width: 420px;
      height: 204px;
      transform: translate(-50%);
      background-color: #f3f3f3;
      border-radius: 6px;
      .real-logo {
        position: absolute;
        top: -64px;
        left: 50%;
        transform: translateX(-50%);
        width: 123px;
        height: 132px;
        background: url("~img/validateQuery/zjcxtc_icon.png") center no-repeat;
      }
      .real-title {
        color: #464646;
        width: 380px;
        text-align: center;
        margin: 76px 20px 0 20px;
      }
      .real-close {
        width: 14px;
        height: 14px;
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        background-image: url("~img/validateQuery/closed_hov_pre_icon.png");
      }
      .real-close:hover {
        background-image: url("~img/validateQuery/closed_nor_icon.png");
      }
      .real-roger {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 38px;
        line-height: 38px;
        color: #fff;
        background-color: #c62e3f;
        text-align: center;
        border-radius:0 0 6px 6px;
        cursor: pointer;
        &:hover {
          background-color: #ea4b5d;
        }
      }
    }
  }
}
</style>
